import { ErrorPages } from '@sitecore-jss/sitecore-jss-nextjs';
import { GetStaticProps } from 'next';
import { PHASE_PRODUCTION_BUILD } from 'next/dist/shared/lib/constants';
import { notFoundPageService } from 'lib/services/404_PageService';
import { siteResolver } from 'lib/site-resolver';
import config from 'temp/config';

export const EmptySitecorePageProps = {
  componentProps: {},
  dictionary: {},
  layoutData: {
    sitecore: {
      route: {
        name: '',
        placeholders: {
          'abrdn-header': [],
          'abrdn-main': [],
          'abrdn-footer': [],
        },
      },
      context: {},
    },
  },
  pageData: {
    pageTitle: '404 Page',
  },
  locale: '',
  notFound: false,
  site: {
    name: '',
    hostName: '',
    language: '',
  },
  headLinks: [],
};
import { sitecorePagePropsFactory } from '@/lib/page-props-factory';

import SitecorePage from './[[...path]]';

export const getStaticProps: GetStaticProps = async (context) => {
  if (process.env.NEXT_PHASE === PHASE_PRODUCTION_BUILD) {
    return {
      props: EmptySitecorePageProps,
      revalidate: 5,
    };
  }
  const props = await sitecorePagePropsFactory.create(context);
  let resultErrorPages: ErrorPages | null = null;
  const site = siteResolver.getByName(config.sitecoreSiteName);
  const [lang, region] = props?.site?.language.split('-');
  const upperCased = region ? `${lang}-${region.toUpperCase()}` : lang;

  try {
    resultErrorPages = await notFoundPageService.getNotFoundPageData(upperCased, site.name);
  } catch (error) {
    console.log('Error occurred while fetching error pages');
    console.log(error);
  }

  props.layoutData = resultErrorPages?.notFoundPage?.rendered || EmptySitecorePageProps.layoutData;

  return {
    props,
    revalidate: 5,
  };
};

const Custom404 = SitecorePage;

export default Custom404;
